export const createQuickTasksRoutes = (basePath: string) =>
  ({
    index: basePath,
  }) as const;
